import { ITableFields, TableFieldsValue } from './types';
import { GetRecentlyDeletedParams } from 'lib/api/recentlyDeletedApi';
import { TFunction } from 'i18next';

export const getTableFields = (t: TFunction): ITableFields[] => [
  {
    value: TableFieldsValue.TITLE,
    label: t('Title or name'),
  },
  {
    value: TableFieldsValue.TYPE,
    label: t('Type'),
  },
  {
    value: TableFieldsValue.CREATED_AT,
    label: t('Deleted on'),
  },
  {
    value: TableFieldsValue.DAYS,
    label: t('Days Until Deleted'),
  },
  {
    value: TableFieldsValue.RESTORE,
    label: t('Restore'),
  },
];

export const checkIfContainsEmptyString = (params: any) =>
  Object.keys(params)
    .filter(key => params[key] !== '')
    .reduce(
      (obj, key) => {
        return {
          ...obj,
          [key]: params[key],
        };
      },
      { start: 0, limit: 10 }
    ) as GetRecentlyDeletedParams;
